import useSessionStore from '@cobliteam/hooks/src/useSession/store/useSessionStore';
import useUserData from './useUserData';

export interface FleetHealth {
  /** Grupo restrito só contém `no-valid-groups` — o único grupo do usuário foi deletado. */
  hasNoValidGroups: boolean;
  /** Todos os grupos do usuário existem, mas nenhum tem veículo. */
  hasOnlyGroupsWithNoVehicles: boolean;
  /** Conveniência: `hasNoValidGroups || hasOnlyGroupsWithNoVehicles`. */
  noValidGroupOrVehicles: boolean;
}

/**
 * Deriva flags de saúde da frota corrente a partir do `userData` cacheado. Não dispara fetch —
 * delega para `useUserData(false)`, que compartilha a mesma query e evita registrar uma queryFn
 * paralela na mesma queryKey (essa duplicidade fazia um `invalidateQueries` refazer o fetch com
 * a `session` capturada no closure — stale-closure em troca de frota).
 */
const useFleetHealth = (): FleetHealth => {
  const session = useSessionStore((s) => s.session);
  const { data: userData } = useUserData(false);

  const currentFleet = userData?.userFleets?.find((f) => f.id === session?.fleet.id);
  const hasNoValidGroups = currentFleet?.hasNoValidGroups ?? false;
  const hasOnlyGroupsWithNoVehicles = currentFleet?.hasOnlyGroupsWithNoVehicles ?? false;

  return {
    hasNoValidGroups,
    hasOnlyGroupsWithNoVehicles,
    noValidGroupOrVehicles: hasNoValidGroups || hasOnlyGroupsWithNoVehicles,
  };
};

export default useFleetHealth;
